import React from 'react';
import _ from 'lodash';
import { Box, Tooltip, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import Scrollbar from '../../../../components-core/Scrollbar';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components-core/data-grid/DataGridToolbar';
import { transportColumns } from '../../../../services/column-definitions';
import TransportDetails from './TransportDetails';

export const TransportList = props => {
  const { onOpenSidebar, hideSidebar, transports, queryCallback, loading, submitCallback, allResorts, allSeasons } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);

  const handleDetailsCheck = (data, doubleClick = false) => {
    setEditRowData(data);
    if (doubleClick) {
      setFullScreen(true);
    }
    setOpenCompose(true);
  };
  const [columns, setColumns] = React.useState(transportColumns(handleDetailsCheck));

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <Box sx={{ opacity: loading ? 0.5 : 1 }}>
      <TransportDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
        allResorts={allResorts}
        allSeasons={allSeasons}
      />
      <Box display="flex" justifyContent="center">
        <Tooltip title="Dodaj transport" sx={{ mb: 1 }}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => {
              setFullScreen(true);
              setOpenCompose(true);
            }}
          >
            <AddIcon style={{ fontSize: '30px' }} />
          </Fab>
        </Tooltip>
      </Box>
      <Scrollbar>
        <Box sx={{ minWidth: { md: 800 } }}>
          <DataGridPro
            columns={columns}
            rows={transports}
            density="compact"
            disableColumnMenu={true}
            autoPageSize={false}
            autoHeight={true}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            components={{
              Toolbar: DataGridToolbar
            }}
            componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: true, searchCallback } }}
            localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
            disableSelectionOnClick
            onRowDoubleClick={params => handleDetailsCheck(params.row, true)}
            onRowClick={params => {
              setEditRowData(params.row);
              setFullScreen(true);
              setOpenCompose(true);
            }}
          />
        </Box>
      </Scrollbar>
    </Box>
  );
};
